import { create } from "zustand";

import STRINGS from "../../utils/strings";

const initialState = {
  data: [],
  loading: false,
  currentPage: STRINGS.DEFAULT_PAGE,
  resLimit: 25,
  resultCount: 0,
};

export const useProviderStatusHistoryStore = create((set) => ({
  ...initialState,

  setData: (data) => set({ data }),
  setLoading: (loading) => set({ loading }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setResLimit: (resLimit) => set({ resLimit }),
  setResultCount: (resultCount) => set({ resultCount }),
  reset: () => set(initialState),
}));
